import { IZIndexConfig } from './z-index-config.interface';

/**
 * Settings for z-index
 */
export class ZIndexConfig implements IZIndexConfig {
  /** Start z-index the z-index service/store should use */
  zIndex = 0;
}
